import { Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { StringUtils } from '../utils/stringUtils';
import { HttpClient } from '@angular/common/http';
import { NetworkServices } from './networkServices';
import { NotificationServices } from './notificationServices';
import { StorageServices } from './storageService';
import { ConfigUtils } from '../utils/configUtils';
import { DocCarteraMsg } from '../msg/carteraMsg';
import { NumberUtils } from '../utils/numberUtils';

export class PagoServices{
  
  private _printRecibo:Subject<any>=new Subject<any>();
  constructor(){}
  static facturasAPagar: any[];
  printRecibo(pago){
    this._printRecibo.next(pago);
  }
  onPrintRecibo():Observable<any>{
    return this._printRecibo.asObservable();
  }
  static getTotalAPagar(facturasAPagar){
    if(!facturasAPagar)
        return 0;
    var totalAPagar=0;
    facturasAPagar.forEach(fact=>{
        totalAPagar+= DocCarteraMsg.getToPayMasProntoPago(fact);
        totalAPagar=NumberUtils.round(totalAPagar,2);
    });
    if(totalAPagar<0)
        totalAPagar=0;
    return totalAPagar;
  }
  static setTotalPagado(me){
    me.totalPagado=0;
    if(me.tiposPago && me.tiposPago.length>0){
        me.tiposPago.forEach(tp=>me.totalPagado+=tp.monto);
        me.totalPagado=NumberUtils.round(me.totalPagado,2);
    }
}
}


